// Product Card Size Selector & Color Selector

function getVariantImageForViewport(element) {
  if (
    window.matchMedia('(max-width: 749px)').matches &&
    element.dataset.variantImageMobile
  ) {
    return element.dataset.variantImageMobile;
  }

  return element.dataset.variantImage;
}


// Initialize: Set first available color as active on page load
document.addEventListener('DOMContentLoaded', function() {
  // Handle regular color swatches
  document.querySelectorAll('.product-card-color-selector').forEach(colorSelector => {
    const firstActiveColor = colorSelector.querySelector('.color-swatch-button:not(.color-swatch-button--disabled)');
    if (firstActiveColor && !colorSelector.querySelector('.color-swatch-button.active')) {
      firstActiveColor.classList.add('active');

    }
  });

  // Handle luxury variant pickers and set data-selected-color on card
  document.querySelectorAll('.luxury-variant-picker').forEach(luxuryPicker => {
    const card = luxuryPicker.closest('.card-wrapper, .collection-card-wrapper');
    const activeVariant = luxuryPicker.querySelector('.luxury-variant-item.active');

    if (activeVariant && card) {
      const selectedColor = activeVariant.dataset.colorName;
      card.setAttribute('data-selected-color', selectedColor);

    }
  });
});

document.addEventListener('click', function(e) {
  // Handle simple add to cart button (for products without size variants)
  const simpleAddButton = e.target.closest('.simple-add-to-cart-button');
  if (simpleAddButton) {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Check if this is a "Notify Me" button (sold out product)
    if (simpleAddButton.classList.contains('notify-me-button')) {

      showBackInStockModalForProduct(simpleAddButton);
      return;
    }

    const variantId = simpleAddButton.dataset.variantId;


    if (variantId) {
      addToCart(variantId, simpleAddButton);
    } else {
      const productUrl = simpleAddButton.dataset.productUrl;

      window.location.href = productUrl;
    }
    return;
  }

  // Handle size button clicks
  const sizeButton = e.target.closest('.size-button');
  if (sizeButton) {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Check if button is disabled/out of stock - show notification modal
    if (sizeButton.classList.contains('size-button--disabled') || sizeButton.disabled) {

      showBackInStockModal(sizeButton);
      return;
    }

    // If we already have a direct variant id, add to cart immediately
    const directVariantId = sizeButton.dataset.variantId;
    if (directVariantId) {
      addToCart(directVariantId, sizeButton);
      return;
    }

    // Get the selected color variant's option value
    const card = sizeButton.closest('.card-wrapper, .collection-card-wrapper');



    // Check luxury variant picker first (data attribute set by luxury-variant-picker.js)
    let selectedColor = card ? card.getAttribute('data-selected-color') : null;


    // Fallback to old color swatch button method if luxury picker not used
    if (!selectedColor) {
      const activeColorButton = card.querySelector('.color-swatch-button.active');
      selectedColor = activeColorButton ? activeColorButton.dataset.colorValue : null;

    } else {

    }

    // Parse variant data
    const variantData = sizeButton.dataset.variants;
    const productUrl = sizeButton.dataset.productUrl;




    if (!variantData) {

      window.location.href = productUrl;
      return;
    }

    // Find the matching variant based on selected color and size
    const variants = variantData.split('|');
    const clickedSize = sizeButton.textContent.trim();



    let matchedVariant = null;
    let fallbackVariant = null; // For matching color but unavailable
    let fallbackAnyVariant = null; // For any size match as last resort

    for (const variantStr of variants) {
      const [id, available, opt1, opt2, opt3] = variantStr.split(':');


      // Check if this variant matches the clicked size
      const variantHasSize = opt1 === clickedSize || opt2 === clickedSize || opt3 === clickedSize;

      if (!variantHasSize) {

        continue; // Skip variants that don't match the size
      }



      // Store first matching size as ultimate fallback
      if (!fallbackAnyVariant) {
        fallbackAnyVariant = id;

      }

      // If a color is selected, find variant matching both color AND size
      if (selectedColor) {
        // Normalize strings for comparison (trim whitespace and compare case-insensitively)
        const selectedColorNormalized = selectedColor.trim().toLowerCase();
        const opt1Normalized = opt1 ? opt1.trim().toLowerCase() : '';
        const opt2Normalized = opt2 ? opt2.trim().toLowerCase() : '';
        const opt3Normalized = opt3 ? opt3.trim().toLowerCase() : '';

        const variantHasColor = opt1Normalized === selectedColorNormalized ||
                                opt2Normalized === selectedColorNormalized ||
                                opt3Normalized === selectedColorNormalized;


        if (variantHasColor) {
          if (available === 'true') {
            // Perfect match: correct color, correct size, and available
            matchedVariant = id;

            break;
          } else if (!fallbackVariant) {
            // Good match but not available: correct color, correct size
            fallbackVariant = id;

          }
        } else {

        }
      } else {
        // No color selected, just find first available variant with this size

        if (available === 'true') {
          matchedVariant = id;

          break;
        }
      }
    }

    // Use fallback logic: prioritize color match even if unavailable
    if (!matchedVariant) {
      if (fallbackVariant) {
        matchedVariant = fallbackVariant;

      } else if (fallbackAnyVariant) {
        matchedVariant = fallbackAnyVariant;

      }
    }





    if (matchedVariant) {
      addToCart(matchedVariant, sizeButton);
    } else {

      window.location.href = productUrl;
    }
    return;
  }

  // Handle luxury variant picker clicks (for collection products with square swatches)
  const luxuryVariantButton = e.target.closest('.luxury-variant-item');
  if (luxuryVariantButton) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (luxuryVariantButton.classList.contains('unavailable')) {
      return;
    }

    const variantImage = getVariantImageForViewport(luxuryVariantButton);
    const selectedColor = luxuryVariantButton.dataset.colorName;
    const variantId = luxuryVariantButton.dataset.variantId;
    const card = luxuryVariantButton.closest('.card-wrapper, .collection-card-wrapper');



    // Update active state
    const allVariantButtons = card.querySelectorAll('.luxury-variant-item');
    allVariantButtons.forEach(btn => btn.classList.remove('active'));
    luxuryVariantButton.classList.add('active');

    // CRITICAL: Update data-selected-color attribute so size buttons know which color is selected
    if (card) {
      card.setAttribute('data-selected-color', selectedColor);

    }

    // Update the Add to Cart button's variant ID for products without sizes
    const addToCartButton = card.querySelector('.simple-add-to-cart-button');
    if (addToCartButton && variantId) {
      addToCartButton.dataset.variantId = variantId;

    }

    // Update product image
    if (variantImage) {


      let productImage = card.querySelector('.product-card-image-link .media img:first-child');

      if (!productImage) {
        productImage = card.querySelector('.card__media img:first-child');
      }

      if (!productImage) {
        productImage = card.querySelector('.media img:first-child');
      }

      if (productImage) {

        productImage.src = variantImage;

        if (productImage.srcset) {
          productImage.srcset = variantImage;
        }
      } else {

      }
    }

    // Update size button availability based on selected color
    const sizeButtons = card.querySelectorAll('.size-button');
    sizeButtons.forEach(btn => {
      const variantData = btn.dataset.variants;
      if (!variantData) return;

      const variants = variantData.split('|');
      let hasAvailable = false;

      for (const variantStr of variants) {
        const [id, available, opt1, opt2, opt3] = variantStr.split(':');
        // Normalize for comparison
        const selectedColorNormalized = selectedColor.trim().toLowerCase();
        const opt1Normalized = opt1 ? opt1.trim().toLowerCase() : '';
        const opt2Normalized = opt2 ? opt2.trim().toLowerCase() : '';
        const opt3Normalized = opt3 ? opt3.trim().toLowerCase() : '';

        if ((opt1Normalized === selectedColorNormalized || opt2Normalized === selectedColorNormalized || opt3Normalized === selectedColorNormalized) && available === 'true') {
          hasAvailable = true;
          break;
        }
      }

      if (hasAvailable) {
        btn.classList.remove('size-button--disabled');
        btn.disabled = false;
      } else {
        btn.classList.add('size-button--disabled');
        btn.disabled = true;
      }
    });

    return;
  }

  // Handle color swatch clicks
  const colorButton = e.target.closest('.color-swatch-button');
  if (colorButton) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (colorButton.classList.contains('color-swatch-button--disabled')) {
      return;
    }

    const variantImage = getVariantImageForViewport(colorButton);
    const selectedColor = colorButton.dataset.colorValue;
    const card = colorButton.closest('.card-wrapper');

    // Update active state
    const allColorButtons = colorButton.parentElement.querySelectorAll('.color-swatch-button');
    allColorButtons.forEach(btn => btn.classList.remove('active'));
    colorButton.classList.add('active');

    // Update product image
    if (variantImage) {


      // Try multiple selectors to find the product image
      let productImage = card.querySelector('.card__media.product-card-media-wrapper .media img:first-child');

      if (!productImage) {
        productImage = card.querySelector('.card__media img:first-child');
      }

      if (!productImage) {
        productImage = card.querySelector('.media img:first-child');
      }

      if (productImage) {

        productImage.src = variantImage;

        // Also update srcset if it exists
        if (productImage.srcset) {
          productImage.srcset = variantImage;
        }
      } else {

      }
    }

    // Update size button availability based on selected color
    const sizeButtons = card.querySelectorAll('.size-button');
    sizeButtons.forEach(btn => {
      const variantData = btn.dataset.variants;
      if (!variantData) return;

      const variants = variantData.split('|');
      let hasAvailable = false;

      for (const variantStr of variants) {
        const [id, available, opt1, opt2, opt3] = variantStr.split(':');
        // Normalize for comparison
        const selectedColorNormalized = selectedColor.trim().toLowerCase();
        const opt1Normalized = opt1 ? opt1.trim().toLowerCase() : '';
        const opt2Normalized = opt2 ? opt2.trim().toLowerCase() : '';
        const opt3Normalized = opt3 ? opt3.trim().toLowerCase() : '';

        if ((opt1Normalized === selectedColorNormalized || opt2Normalized === selectedColorNormalized || opt3Normalized === selectedColorNormalized) && available === 'true') {
          hasAvailable = true;
          break;
        }
      }

      if (hasAvailable) {
        btn.classList.remove('size-button--disabled');
        btn.disabled = false;
      } else {
        btn.classList.add('size-button--disabled');
        btn.disabled = true;
      }
    });

    return;
  }
}, true); // Use capture phase to ensure this fires before other handlers

function addToCart(variantId, button) {
  // Save scroll position before adding to cart
  const scrollPosition = window.scrollY || window.pageYOffset;

  // Show loading state
  const originalText = button.textContent;
  button.textContent = '...';
  button.disabled = true;

  // Convert to number to ensure proper format
  const numericVariantId = parseInt(variantId, 10);

  // Use FormData for cart/add.js with sections parameter (Shopify's recommended approach)
  const formData = {
    items: [{
      id: numericVariantId,
      quantity: 1
    }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(err => {
        throw new Error(err.description || 'Unable to add item to cart');
      });
    }
    return response.json();
  })
  .then(data => {


    // Show success feedback
    button.textContent = '✓';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);

    // Update sections if returned
    if (data.sections) {
      // Update cart icon bubble
      if (data.sections['cart-icon-bubble']) {
        const bubbleElement = document.getElementById('cart-icon-bubble');
        if (bubbleElement) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.sections['cart-icon-bubble'];
          const newContent = tempDiv.querySelector('#cart-icon-bubble');
          if (newContent) {
            bubbleElement.innerHTML = newContent.innerHTML;
          }
        }
      }

      // Update cart drawer
      if (data.sections['cart-drawer']) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          // Remove is-empty class
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }

          // Parse the new HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.sections['cart-drawer'];

          // Find the drawer__inner in the new HTML
          const newDrawerInner = tempDiv.querySelector('.drawer__inner');
          const currentDrawerInner = cartDrawer.querySelector('.drawer__inner');

          if (newDrawerInner && currentDrawerInner) {
            currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

            // Remove is-empty from drawer__inner too
            if (currentDrawerInner.classList.contains('is-empty')) {
              currentDrawerInner.classList.remove('is-empty');
            }
          }

          // Open the drawer and pass the button as trigger
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(button);
          }

          // Restore scroll position after drawer opens
          setTimeout(() => {
            window.scrollTo(0, scrollPosition);
          }, 50);
        }
      }
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.textContent = originalText;
    button.disabled = false;
    alert(error.message || 'Unable to add item to cart. Please try again.');
  });
}

// Back in stock notification modal
function showBackInStockModal(sizeButton) {
  const card = sizeButton.closest('.card-wrapper, .collection-card-wrapper');
  const productTitle = card.querySelector('.product-info-title, .card__heading')?.textContent.trim() || 'this product';
  const size = sizeButton.textContent.trim();
  const productUrl = sizeButton.dataset.productUrl || '';

  // Get selected color
  let selectedColor = card ? card.getAttribute('data-selected-color') : null;
  if (!selectedColor) {
    const activeColorButton = card.querySelector('.luxury-variant-item.active, .color-swatch-button.active');
    selectedColor = activeColorButton ? (activeColorButton.dataset.colorName || activeColorButton.dataset.colorValue) : '';
  }

  // Create modal HTML
  const modalHTML = `
    <div class="back-in-stock-modal" id="backInStockModal">
      <div class="back-in-stock-modal__overlay"></div>
      <div class="back-in-stock-modal__content">
        <button class="back-in-stock-modal__close" aria-label="Close">&times;</button>
        <h3 class="back-in-stock-modal__title">Get notified when this product is back in stock</h3>
        <p class="back-in-stock-modal__product-info">
          <strong>${productTitle}</strong><br>
          ${selectedColor ? `Color: ${selectedColor}<br>` : ''}Size: ${size}
        </p>
        <form class="back-in-stock-modal__form" id="backInStockForm">
          <input
            type="email"
            class="back-in-stock-modal__input"
            placeholder="Enter your email"
            required
            name="email"
          />
          <input type="hidden" name="product" value="${productTitle}" />
          <input type="hidden" name="size" value="${size}" />
          <input type="hidden" name="color" value="${selectedColor}" />
          <input type="hidden" name="url" value="${productUrl}" />
          <button type="submit" class="back-in-stock-modal__button">Notify me</button>
        </form>
        <div class="back-in-stock-modal__success" style="display: none;">
          <p>✓ You'll be notified when this item is back in stock!</p>
        </div>
      </div>
    </div>
  `;

  // Remove existing modal if any
  const existingModal = document.getElementById('backInStockModal');
  if (existingModal) {
    existingModal.remove();
  }

  // Add modal to page
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  const modal = document.getElementById('backInStockModal');
  const closeBtn = modal.querySelector('.back-in-stock-modal__close');
  const overlay = modal.querySelector('.back-in-stock-modal__overlay');
  const form = modal.querySelector('#backInStockForm');

  // Show modal with animation
  setTimeout(() => modal.classList.add('active'), 10);

  // Close modal function
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => modal.remove(), 300);
  }

  // Event listeners
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  // Handle form submission
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Show success message
    form.style.display = 'none';
    modal.querySelector('.back-in-stock-modal__success').style.display = 'block';

    // Close modal after 2 seconds
    setTimeout(closeModal, 2000);
  });
}

// Back in stock notification modal for completely sold out products
function showBackInStockModalForProduct(button) {
  const productTitle = button.dataset.productTitle || 'this product';
  const productUrl = button.dataset.productUrl || '';

  // Create modal HTML
  const modalHTML = `
    <div class="back-in-stock-modal" id="backInStockModal">
      <div class="back-in-stock-modal__overlay"></div>
      <div class="back-in-stock-modal__content">
        <button class="back-in-stock-modal__close" aria-label="Close">&times;</button>
        <h3 class="back-in-stock-modal__title">Get notified when this product is back in stock</h3>
        <p class="back-in-stock-modal__product-info">
          <strong>${productTitle}</strong>
        </p>
        <form class="back-in-stock-modal__form" id="backInStockForm">
          <input
            type="email"
            class="back-in-stock-modal__input"
            placeholder="Enter your email"
            required
            name="email"
          />
          <input type="hidden" name="product" value="${productTitle}" />
          <input type="hidden" name="url" value="${productUrl}" />
          <button type="submit" class="back-in-stock-modal__button">Notify me</button>
        </form>
        <div class="back-in-stock-modal__success" style="display: none;">
          <p>✓ You'll be notified when this item is back in stock!</p>
        </div>
      </div>
    </div>
  `;

  // Remove existing modal if any
  const existingModal = document.getElementById('backInStockModal');
  if (existingModal) {
    existingModal.remove();
  }

  // Add modal to page
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  const modal = document.getElementById('backInStockModal');
  const closeBtn = modal.querySelector('.back-in-stock-modal__close');
  const overlay = modal.querySelector('.back-in-stock-modal__overlay');
  const form = modal.querySelector('#backInStockForm');

  // Show modal with animation
  setTimeout(() => modal.classList.add('active'), 10);

  // Close modal function
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => modal.remove(), 300);
  }

  // Event listeners
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  // Handle form submission
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Show success message
    form.style.display = 'none';
    modal.querySelector('.back-in-stock-modal__success').style.display = 'block';

    // Close modal after 2 seconds
    setTimeout(closeModal, 2000);
  });
}
